import { H1 } from "@/components/ui/headings"
import { MainLayout } from "@/novus/layouts/MainLayout"
import React from "react"
import SignInForm from "@/novus/screens/onboarding/components/SignInForm"

const SignInScreen = () => {
  return (
    <MainLayout showLogo={true}>
      <H1>Sign In</H1>
      <SignInForm />
    </MainLayout>
  )
}

export default SignInScreen
